import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddTKCSRateList = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [productName, setProductName] = useState("");
  const [storeProduct, setStoreProduct] = useState([]);

  const [rowAddData, setRowAddData] = useState({
    party_name: "",
    tkcs_rate: "",
    location: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const handleProductChange = (e) => {
    setProductName(e.target.value);
  };

  function resetFields() {
    setRowAddData({
      party_name: "",
      tkcs_rate: "",
      location: "",
    });
    setProductName("");
  }

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { party_name, location, tkcs_rate } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/tkcs-rate/tkcs-rate-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        party_name,
        product_name: productName,
        location,
        tkcs_rate,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const getProductData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };

  useEffect(() => {
    getProductData();
  }, [productName]);
  return (
    <div
      className="modal custom-modal fade"
      id="exampleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Add TKCS Rate
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Add Party Name</h4> */}
                  <form
                    className="form-sample"
                    ref={formRef}
                    onSubmit={handleAddDataSubmit}
                  >
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="party_name">Party Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="party_name"
                            id="party_name"
                            placeholder="Enter Party Name"
                            value={rowAddData.party_name}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="location">Location/Circle</label>
                          <input
                            type="text"
                            className="form-control"
                            name="location"
                            id="location"
                            placeholder="Enter Location/Circle"
                            value={rowAddData.location}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Size">Size</label>
                          <select
                            type="text"
                            className="form-control form-control-lg"
                            name="product"
                            id="Size"
                            onChange={handleProductChange}
                            value={productName}
                            required
                          >
                            <option value="">Select Size</option>
                            {storeProduct &&
                              storeProduct.length > 0 &&
                              storeProduct?.map((item, id) => {
                                return (
                                  <option
                                    value={item.size}
                                    key={id}
                                  >{`${item.size}`}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="tkcs_rate">TKCS Rate</label>
                          <input
                            type="number"
                            className="form-control"
                            name="tkcs_rate"
                            id="tkcs_rate"
                            placeholder="Enter TKCS Rate"
                            value={rowAddData.tkcs_rate}
                            onChange={handleChange}
                            required
                            autoComplete="off"
                            min="0"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={handleAddDataSubmit}
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTKCSRateList;
